function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#33D5BA",
  d: "M32.5 35h-6.563c-.515 0-.937-.422-.937-.938v-3.124c0-.516.422-.938.938-.938H32.5c1.383 0 2.5-1.117 2.5-2.5v-15c0-1.383-1.117-2.5-2.5-2.5h-6.563c-.515 0-.937-.422-.937-.938V5.938c0-.516.422-.938.938-.938H32.5c4.14 0 7.5 3.36 7.5 7.5v15c0 4.14-3.36 7.5-7.5 7.5zm-3.672-15.703L15.703 6.172C14.531 5 12.5 5.82 12.5 7.5V15H1.875C.835 15 0 15.836 0 16.875v7.5c0 1.04.836 1.875 1.875 1.875H12.5v7.5c0 1.68 2.031 2.5 3.203 1.328l13.125-13.125c.727-.734.727-1.922 0-2.656z"
});
function SvgSignin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignin);
export default __webpack_public_path__ + "static/media/signin.df2d93ce185810127e8f2321ef041532.svg";
export { ForwardRef as ReactComponent };